import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ImageFormationObjectRecognition = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Image Formation- Object Recognition"
    videos={[
      "https://www.youtube.com/embed/taC5pMCm70U"
    ]}
    takeaways={[]}
    questions={[
      "Consider the problem of image retrieval in a large-scale database of images. Discuss at least 4 challenges involved in image retrieval, the different approaches that can be used to address these challenges. Write the factors that influence the effectiveness of image retrieval systems."
    ]}
    exampleVideos={[]}
  />
);
}

export default ImageFormationObjectRecognition;
